import { useFetcher, useLoaderData } from '@remix-run/react'
import { json, type LoaderFunctionArgs } from '@remix-run/server-runtime'
import DidYouKnow from '#app/components/Home/DidYouKnow.tsx'
import FastestTime from '#app/components/Home/FastestTime.tsx'
import MostRun from '#app/components/Home/MostRun.tsx'
import Summary from '#app/components/Home/Summary.tsx'
import Welcome from '#app/components/Home/Welcome.tsx'
import { getFastestTime, getMostRacesRun } from '#app/queries/RankingAllData-queries.ts'
import { getNewestResultsSummary } from '#app/queries/Results-queries.ts'

export async function loader(args: LoaderFunctionArgs) {
	const [fastestMale, fastestFemale, summary, most] = await Promise.all([
		getFastestTime('m', 'ageGradedPercent'),
		getFastestTime('f', 'ageGradedPercent'),
		getNewestResultsSummary(),
		getMostRacesRun(),
	])
	return json({
		fastestMale: fastestMale,
		fastestFemale: fastestFemale,
		summary: summary,
		most: most,
	})
}

export default function Index() {
	const loaderData = useLoaderData<typeof loader>()
	return (
		<div className="flex justify-center">
			<div className="flex max-w-[700px] flex-1 flex-col items-center gap-y-4">
				<Welcome />
				<FastestTime
					fastestMale={loaderData?.fastestMale}
					fastestFemale={loaderData?.fastestFemale}
				/>
				<Summary {...loaderData?.summary} />
				<MostRun {...loaderData?.most} />
				<DidYouKnow />
			</div>
		</div>
	)
}
